// extracted by mini-css-extract-plugin
module.exports = {"minWidthXs":"Button_minWidthXs___8Q4c","minWidthSm":"Button_minWidthSm__gTI8E","minWidthMd":"Button_minWidthMd__Y6tPv","minWidthLg":"Button_minWidthLg__gkuQe"};